import React, {useEffect, useState} from 'react';
import {useKeycloak} from '@react-keycloak/web';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {Link, useParams} from 'react-router-dom';

import {Descriptions, Divider, message, Spin, Tag} from 'antd';

import {MedicationTable} from './MedicationTable';
import {findMedicationRequestById} from 'services/MedicationService';
import {findMedicationRequestByRequestId} from 'services/RequestService';
import {handleError} from 'utils/MessageUtils';

const MedicationInfo = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const {id} = useParams();

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const {requestId} = props;
  const [medicationRequestId, setMedicationRequestId] = useState();
  const [medicationRequest, setMedicationRequest] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id?.length > 0 && id !== requestId) {
      setMedicationRequestId(id);
    }
  }, [id]);

  useEffect(() => {
    if (medicationRequestId?.length > 0) {
      setLoading(true);
      findMedicationRequestById(headers, medicationRequestId)
        .then((res) => setMedicationRequest(res.data))
        .catch((error) => handleError(message, error))
        .finally(() => setLoading(false));
    }
  }, [medicationRequestId]);

  useEffect(() => {
    if (requestId) {
      setLoading(true);
      findMedicationRequestByRequestId(headers, requestId)
        .then((res) => setMedicationRequest(res.data))
        .catch((error) => handleError(message, error))
        .finally(() => setLoading(false));
    }
  }, [requestId]);

  return (
    <Spin spinning={loading}>
      <Descriptions
        bordered
        title={intl.messages['common.detail']}
        size='middle'
        style={{paddingTop: 10}}>
        <Descriptions.Item label={intl.messages['diagnostic.disease']} span={2}>
          {medicationRequest?.request?.diagnostic?.disease?.name}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['medication.requester']}>
          {medicationRequest?.requester && (
            <Tag color='green'>
              <Link
                to={`/health/practitioners/${medicationRequest.requester.id}`}>
                {medicationRequest.requester.name}
              </Link>
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={intl.messages['medication.note']} span={3}>
          {medicationRequest?.note}
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      {medicationRequest?.id && (
        <MedicationTable
          request={medicationRequest}
          setRequest={setMedicationRequest}
        />
      )}
    </Spin>
  );
};

export default MedicationInfo;

MedicationInfo.propTypes = {
  requestId: PropTypes.string,
};
